import { render, staticRenderFns } from "./AboutLinks.vue?vue&type=template&id=4e8a58f5&scoped=true"
import script from "./AboutLinks.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutLinks.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AboutLinks.vue?vue&type=style&index=0&id=4e8a58f5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a58f5",
  null
  
)

export default component.exports